{
  "$schema": "./newsletter-routing.schema.json",
  "version": 1,
  "spec": "PRD-01 §2.6 #8 — newsletter-routing rules engine. Each rule fires when its `trigger` predicate matches the user's classification + inputs; matched issues are scored by `weight` and the engine returns the top N matches (N=3 by default) plus a flat list of routing tags for Beehiiv custom_fields. Rules can be added or updated without a code change — this file is the source of truth.",
  "issues": {
    "iron-tests-every-woman": {
      "title": "🩸 The Iron Tests Every Woman Should Get",
      "url": "https://www.femmefortified.com/p/the-iron-tests-every-woman-should-get"
    },
    "why-one-test-isnt-enough": {
      "title": "🧪 Why One Test Isn't Enough",
      "url": "https://www.femmefortified.com/p/why-one-test-isn-t-enough"
    },
    "hemoglobin-shows-up-too-late": {
      "title": "🩸 Hemoglobin—The Iron Marker That Shows Up Too Late",
      "url": "https://www.femmefortified.com/p/hemoglobin-the-iron-marker-that-shows-up-too-late"
    },
    "elevated-ferritin": {
      "title": "🩸 What Does an Elevated Ferritin Result Actually Mean?",
      "url": "https://www.femmefortified.com/p/what-does-an-elevated-ferritin-result-actually-mean"
    },
    "tsat-tibc-what-doctors-dont-explain": {
      "title": "🧪 Transferrin Saturation & TIBC—What Most Doctors Don’t Explain",
      "url": "https://www.femmefortified.com/p/transferrin-saturation-tibc-what-most-doctors-don-t-explain"
    },
    "iron-after-menopause": {
      "title": "🩸 What Happens to Your Iron Levels After Menopause?",
      "url": "https://www.femmefortified.com/p/what-happens-to-your-iron-levels-after-menopause"
    },
    "postpartum-iron-depletion": {
      "title": "🤱 Postpartum Iron Depletion—The Overlooked Recovery Step",
      "url": "https://www.femmefortified.com/p/postpartum-iron-depletion-the-overlooked-recovery-step"
    },
    "extended-breastfeeding-micronutrients": {
      "title": "❤️‍🩹 Does Extended Breastfeeding Deplete Your Micronutrients?",
      "url": "https://www.femmefortified.com/p/does-extended-breastfeeding-deplete-your-micronutrients"
    },
    "birth-control-iron-energy": {
      "title": "🌀 How Your Birth Control Method Directly Impacts Your Iron Levels (And Daily Energy)",
      "url": "https://www.femmefortified.com/p/how-your-birth-control-method-directly-impacts-your-iron-levels-and-daily-energy"
    },
    "drained-iron-energy": {
      "title": "😮‍💨 Drained? How Iron Impacts Your Energy and Simple Steps to Start Feeling Better",
      "url": "https://www.femmefortified.com/p/drained-how-iron-impacts-your-energy-and-simple-steps-to-start-feeling-better"
    },
    "low-b12-vs-low-iron": {
      "title": "🩸 Low B12 vs Low Iron: The Symptom Split",
      "url": "https://www.femmefortified.com/p/low-b12-vs-low-iron-the-symptom-split"
    },
    "hidden-costs-of-iron-deficiency": {
      "title": "🔍 The Hidden Costs of Iron Deficiency—Even When You Feel Fine",
      "url": "https://www.femmefortified.com/p/the-hidden-costs-of-iron-deficiency-even-when-you-feel-fine"
    },
    "acid-blockers-and-iron": {
      "title": "🔥 Acid Blockers and Iron: When Relief Comes at a Cost",
      "url": "https://www.femmefortified.com/p/acid-blockers-and-iron-when-relief-comes-at-a-cost"
    },
    "iron-supplement-not-working": {
      "title": "🚨 Why Your Iron Supplement Might Not Be Working",
      "url": "https://www.femmefortified.com/p/why-your-iron-supplement-might-not-be-working"
    },
    "smart-iron-supplement-guide-pt1": {
      "title": "💊 The Smart Woman’s Guide to Iron Supplements (Part 1): Choosing the Best One for You",
      "url": "https://www.femmefortified.com/p/the-smart-woman-s-guide-to-iron-supplements-part-1-choosing-the-best-one-for-you"
    },
    "eat-18mg-iron-day": {
      "title": "🥬 What It Actually Takes to Eat 18 mg of Iron in a Day",
      "url": "https://www.femmefortified.com/p/what-it-actually-takes-to-eat-18-mg-of-iron-in-a-day"
    },
    "iron-fortified-foods-meals": {
      "title": "🥣 Iron-Fortified Foods Can’t Help You If You Do This at Meals",
      "url": "https://www.femmefortified.com/p/iron-fortified-foods-can-t-help-you-if-you-do-this-at-meals"
    },
    "matcha-iron-tiktok": {
      "title": "🤳🏼 TikTok Says Matcha Can Lower Iron — Here’s How It Works",
      "url": "https://www.femmefortified.com/p/tiktok-says-matcha-can-lower-iron-here-s-how-it-works"
    },
    "women-designed-iron-deficient": {
      "title": "🏭 Are Women Designed to Be Iron-Deficient? How Innovation Made Iron Harder to Get",
      "url": "https://www.femmefortified.com/p/are-women-designed-to-be-iron-deficient-how-innovation-made-iron-harder-to-get"
    },
    "fortification-was-supposed-to-save-us": {
      "title": "🍞 Fortification Was Supposed to Save Us—So Why Are Women Still Deficient?",
      "url": "https://www.femmefortified.com/p/fortification-was-supposed-to-save-us-so-why-are-women-still-deficient"
    }
  },
  "rules": [
    {
      "tag": "default",
      "weight": 5,
      "trigger": {
        "kind": "always"
      },
      "issues": [
        "iron-tests-every-woman",
        "why-one-test-isnt-enough"
      ]
    },
    {
      "tag": "hb-only",
      "weight": 7,
      "trigger": {
        "kind": "completeness",
        "value": "tier_1_cbc_only"
      },
      "issues": [
        "hemoglobin-shows-up-too-late"
      ]
    },
    {
      "tag": "elevated-ferritin",
      "weight": 8,
      "trigger": {
        "kind": "patternIdAny",
        "values": [
          "very_high_ferritin_any_stage",
          "iron_overload_trigger_premenopausal",
          "iron_overload_trigger_postmenopausal"
        ]
      },
      "issues": [
        "elevated-ferritin"
      ]
    },
    {
      "tag": "tsat-tibc",
      "weight": 5,
      "trigger": {
        "kind": "anyLabPresent",
        "fields": [
          "tsat",
          "tibc"
        ]
      },
      "issues": [
        "tsat-tibc-what-doctors-dont-explain"
      ]
    },
    {
      "tag": "postmenopausal",
      "weight": 6,
      "trigger": {
        "kind": "lifeStage",
        "value": "postmenopausal"
      },
      "issues": [
        "iron-after-menopause"
      ]
    },
    {
      "tag": "postpartum",
      "weight": 7,
      "trigger": {
        "kind": "lifeStage",
        "value": "postpartum_within_6mo"
      },
      "issues": [
        "postpartum-iron-depletion",
        "extended-breastfeeding-micronutrients"
      ]
    },
    {
      "tag": "menstruating",
      "weight": 4,
      "trigger": {
        "kind": "lifeStage",
        "value": "non_pregnant_premenopausal"
      },
      "issues": [
        "birth-control-iron-energy"
      ]
    },
    {
      "tag": "fatigue-heavy",
      "weight": 6,
      "trigger": {
        "kind": "symptomAny",
        "values": [
          "unusual_fatigue"
        ]
      },
      "issues": [
        "drained-iron-energy"
      ]
    },
    {
      "tag": "b12-overlap",
      "weight": 5,
      "trigger": {
        "kind": "symptomAll",
        "values": [
          "unusual_fatigue",
          "cold_intolerance"
        ]
      },
      "issues": [
        "low-b12-vs-low-iron"
      ]
    },
    {
      "tag": "normal-but-symptoms",
      "weight": 6,
      "trigger": {
        "kind": "normalLabsButSymptoms"
      },
      "issues": [
        "hidden-costs-of-iron-deficiency"
      ]
    },
    {
      "tag": "acid-blockers",
      "weight": 7,
      "trigger": {
        "kind": "absorptionCondition",
        "value": "acid_blocker_use"
      },
      "issues": [
        "acid-blockers-and-iron"
      ]
    },
    {
      "tag": "supplementing",
      "weight": 7,
      "trigger": {
        "kind": "ironSupplementation",
        "value": "currently"
      },
      "issues": [
        "iron-supplement-not-working",
        "smart-iron-supplement-guide-pt1"
      ]
    },
    {
      "tag": "plant-forward",
      "weight": 5,
      "trigger": {
        "kind": "diet",
        "value": "plant_forward"
      },
      "issues": [
        "eat-18mg-iron-day"
      ]
    },
    {
      "tag": "coffee-tea-with-meals",
      "weight": 6,
      "trigger": {
        "kind": "coffeeTeaHabit",
        "value": "with_meals"
      },
      "issues": [
        "iron-fortified-foods-meals",
        "matcha-iron-tiktok"
      ]
    },
    {
      "tag": "foundational",
      "weight": 2,
      "trigger": {
        "kind": "always"
      },
      "issues": [
        "women-designed-iron-deficient",
        "fortification-was-supposed-to-save-us"
      ]
    }
  ],
  "settings": {
    "maxIssues": 3,
    "alwaysIncludeTagInBeehiiv": [
      "default"
    ]
  }
}